import { render, staticRenderFns } from "./OperationGroupEditIframe.vue?vue&type=template&id=1c87b9c3&"
import script from "./OperationGroupEditIframe.vue?vue&type=script&lang=ts&"
export * from "./OperationGroupEditIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports